
import Vue from 'vue'
import { downloadGET } from '@/api/api'
import { readAsText, readAsDataURL, downloadFile } from '@/utils'
import {canPreviewList, previewMode} from '@/utils/commonDef'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

export default Vue.extend({
  name: 'mixin',
  data() {
    return {
      showFileInfo: false,// 是否展示预览
      fileInfo: {}, // 文件详情
      previewMode: 'text', // 预览格式
      previewLoading: false, // 文件预览加载状态
      content: '', // txt文件内容
      previewEncode: 'UTF-8', // txt文件内容预览编码格式
      txtBlob: '' // txt文件流
    }
  },
  watch: {
    async previewEncode(val) {
      this.setContent('', true)
      let result = await readAsText(this.txtBlob, val)
      this.setContent(result, false)
    }
  },
  methods: {
    // 下载或预览文件，readOnly：true 预览，false 下载
    handleDownload(data: any, readOnly?: boolean) {
      if (readOnly) {
        this.setContent('', true)
      }
      if (data.suffix.toLowerCase() === 'pdf') {
        data.contentType = 'application/pdf'
        if(readOnly){
          resourceService.statFileUsingGET(data.objectKey).then(res=>{
            this.previewMode = "pdf"
            this.setContent(res.data.link, false)
          })
          return
        }        
      }

      downloadGET(data.objectKey, data.objectKey, data.contentType).then((res: any) => {
        this.txtBlob = res
        if (readOnly) { // 预览
          this.filePreview(res, data)
        } else { // 下载
          downloadFile(res, data.originalFilename || data.fileName)
        }
      }, (err) => {
        // this.$message.error(err)
        this.setContent('', false)
      })
    },
    // 文件预览
    async filePreview(content: any, file: any) {
      let url: any
      let a = /.*\.(.*)$/
      let suffix = ''
      let name = file.originalFilename ? file.originalFilename : file.fileName
      if (name.indexOf('.') != -1) {
        suffix = a.exec(name)[1]
      } else {
        suffix = 'nc'
      }
      // 匹配不到已存在格式的文件直接以nc格式打开
      if (!canPreviewList.includes(suffix.toLowerCase())) {
        // 直接下载
        // downloadFile(content, file.originalFilename || file.fileName)
        let result = await readAsText(content, this.previewEncode)
        this.setContent(result, false)
      } else {
        for (let key in previewMode) {
          previewMode[key].map(async (item)=>{
            if(suffix.toLowerCase() === item) {
              this.previewMode = key
              switch (key) {
                case 'text':
                  let result = await readAsText(content, this.previewEncode)
                  this.setContent(result, false)
                  break
                case 'image':
                  url = await readAsDataURL(content)
                  this.setContent(url, false)
                  break
              }
            }
          })
        }
      }
     /* switch (suffix.toLowerCase()) {
        case 'txt':
        case 'nc':
        case '':
        case 'json':
        case 'mpf':
        case 'spf':
        case 'eia':
        case 'stp':
        case 'prg':
        case 'tap':
          this.previewMode = 'text'
          let result = await readAsText(content, this.previewEncode)
          this.setContent(result, false)
          break
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'svg':
        case 'gif':
        case 'bmp':
          this.previewMode = 'image'
          url = await readAsDataURL(content)
          this.setContent(url, false)
          break
        case 'pdf':
          this.previewMode = 'pdf'
          // url = await readAsDataURL(content)
          url = URL.createObjectURL(content)
          this.setContent(url, false)
          break
        default:
          // 直接下载
          downloadFile(content, file.originalFilename || file.fileName)
      }*/
    },
    // 打开文件预览并立即展示标题
    handleShowFileInfo(record: any) {
      this.fileInfo = {}
      this.fileInfo = record
      const canPreview = canPreviewList
      let a = /.*\.(.*)$/
      let suffix = ''
      let name = record.originalFilename ? record.originalFilename : record.fileName
      if (name.indexOf('.') != -1) {
        suffix = a.exec(name)[1]
      } else {
        suffix = 'nc'
      }
      console.log(suffix)
      if (canPreview.includes(suffix.toLowerCase())) {
        this.showFileInfo = true
        this.previewEncode = 'UTF-8'
        this.previewMode = 'image'
        this.handleDownload(record, true)
      } else { // 不识别的格式统一按nc格式打开预览
        this.showFileInfo = true
        this.previewEncode = 'UTF-8'
        this.previewMode = 'text'
        this.handleDownload(record, true)
        /*this.handleDownload(record)
        this.setContent('', false)
        this.hiddenFileInfo()*/

      }
    },
    // 设置预览的内容
    setContent(data: string, status: boolean) {
      this.content = data
      this.previewLoading = status
    },
    // 关闭文件预览
    hiddenFileInfo() {
      this.showFileInfo = false
    },
    // 更改预览txt文件的编码格式
    changeEncode(type: string) {
      this.previewEncode = type
    },
    handleAction(data: any) {
      const { record, type } = data
      switch (type) {
        case 'delete':
          this.handleDelete(record)
          break
        case 'download':
          this.handleDownload(record)
          break
        case 'preview':
          this.handleShowFileInfo(record)
          break
      }
    }
  }
})
